import React, { useEffect, useState } from 'react'
import { ClipLoader } from 'react-spinners'
import { LoaderButton } from '../../LoaderButton'
import { S_ClientFundingRequest } from './ClientFundingRequest.style'
import { FormRow } from '../../Forms/FormRow'
import { getFundingRequestClientDetails } from '../../../_services/lender.service'
import { formatCurrency } from '../../../_helpers/formatting'
import { createNewFundingRequestWithDetails } from '../../../_services/requestCapital.service'
import { useModal } from '../../../_reduxHooks/modal.hook'
import { InfoModal } from '../info/InfoModal'

export const ClientFundingRequest = ({ business, onCreate }) => {
  const [requestAmt, setRequestAmt] = useState(0)
  const [creating, setCreating] = useState(false)
  const [availability, setAvailability] = useState(0)
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)
  const { openModal, closeModal } = useModal()
  useEffect(() => {
    setLoading(true)
    getFundingRequestClientDetails(business.id).then((frDetails) => {
      setAvailability(Number(frDetails?.client_reserve?.amount ?? 0))
      setLoading(false)
    })
  }, [])
  const validateRequestAmt = (amt) => {
    if (amt == 0 || (amt > 0 && amt <= availability)) {
      setError(null)
    } else if (amt > availability) {
      setError('Request amount must not exceed availability.')
    }
  }
  const createFundingRequest = () => {
    setCreating(true)
    createNewFundingRequestWithDetails(business.id, { amount: requestAmt }).then((fr) => {
      setCreating(false)
      closeModal()
      openSuccessModal()
      if (typeof onCreate === 'function') {
        onCreate(fr)
      }
    })
  }

  const openSuccessModal = () => {
    const message = `The Funding Request was submitted successfully.`

    openModal(InfoModal, {
      content: message,
      buttonText: 'Close',
    })
  }
  return (
    <S_ClientFundingRequest>
      <h2>Request Funding</h2>
      <div className={'row'}>
        <div>Total Available:</div>
        <div>{loading ? <ClipLoader size={16} /> : formatCurrency(availability)}</div>
      </div>
      <div className={'row'}>
        <div>Request Amount:</div>
        <div className={'field-row'}>
          <FormRow
            error={error}
            onChange={(newVal) => {
              setRequestAmt(newVal)
              validateRequestAmt(newVal)
            }}
            type="currency"
          />
        </div>
      </div>
      <div className={'submit-row'}>
        <LoaderButton disabled={requestAmt == 0 || !!error} isLoading={creating} onClick={createFundingRequest}>
          Submit
        </LoaderButton>
      </div>
    </S_ClientFundingRequest>
  )
}
